<template>
  <div>
    <v-header></v-header>

    <div style="padding-top: 60px;">
      <div class="banner">
        <img src="../../static/img/businessCooperation_banner_01.png" alt="" />
        <h2 class="item-title">
          <span class="ch">凡高云校园一站式解决方案</span>
          <span class="egone"></span>
          <span class="eg">
                                目前凡高云校园为国内5000+所中小学提供云校园解决方案，
依托于强大的互联网技术积累，为学校打造智能管理平台和优
质化资源共享平台，服务于老师教和学生学、排、管、评，让
学校管理更高效、学生学习更轻松、师生互动更活跃、家校沟
通更便捷，越来越多的学校正在加入凡高云校园
                            </span>
        </h2>
      </div>
     
       <div   class="solution">
          <h2   class="item-title"><span   class="eg">优秀学校案例</span> <span   class="ch">致力于帮助客户解决实际业务场景问题</span></h2>
          <swipe class="my-swipetwo" :speed="500" :auto="5000">
              <swipe-item class="slide1">
                 <div   class="item-pro" >
                      <dl  >
                        <dt  >
                          <img src="../../static/img/yx-erzhong.png">
                        </dt>
                        <dd  >
                          <span   class="titlies">河北衡水市第二中学</span>
                          <span   class="note">凡高教育系统为我校的招生，缴费，一卡通，管理，教务，财务，校园安全等工作提供了统一正规高效的流程提高了学校的管理水平与效率！实现集团校业务标准化、数字化管理。</span>
                        </dd>
                      </dl>
                    </div>
              </swipe-item>
              <swipe-item class="slide2">
                  
                     <div   class="item-pro" >
                      <dl  >
                        <dt  >
                          <img src="../../static/img/yx-shi.png">
                        </dt>
                        <dd  >
                          <span   class="titlies">石家庄精英中学</span>
                          <span   class="note">以前开学收费比较慢，家长要在财务处排半天队；老师们收费、记账，工作繁重。现在，幼儿园将收费二维码分享给家长，家长用微信扫一扫，随时随地就能缴费，免去请假排队、浪费时间。老师在学加家后台实时查看收费状况，一键导出财务报表，效率大幅提升。</span>
                        </dd>
                      </dl>
                    </div>
              </swipe-item>
            
              <swipe-item class="slide3">
                  <div   class="item-pro" >
                    <dl  >
                      <dt  >
                        <img src="../../static/img/yx-wuzhong.png">
                      </dt>
                      <dd  >
                        <span   class="titlies">河北衡水市第五中学</span>
                        <span   class="note">学生招生是一个很繁杂的工作，学生的报名信息很多，使用了凡高的招生缴费系统之后学生信息更明晰，线上一键审核，招生审核效率更高，还有线上缴费非常快捷。</span>
                      </dd>
                    </dl>
                  </div> 
              </swipe-item>
          </swipe>
      </div>


      <div   class="productfooter">
        <h2   class="item-title">
          <span   class="eg">合作伙伴</span> 
          
        </h2>
        <div   class="item-pro">
          <dl >
            <dt  >
              <img src="../../static/img/school-1.png">
            </dt>
            <dd  >
              <span   class="note">衡水市第二中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-2.png">
            </dt>
            <dd  >
              <span   class="note">支付宝</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-3.png">
            </dt>
            <dd  >
              <span   class="note">石家庄精英中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-4.png">
            </dt>
            <dd  >
             
              <span   class="note">衡水第五中学</span>
            </dd>
           
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-5.png">
            </dt>
            <dd  >
              <span   class="note">武邑中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-6.png">
            </dt>
            <dd  >
              <span   class="note">光大银行</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-7.png">
            </dt>
            <dd  >
              <span   class="note">衡水市第十三中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-8.png">
            </dt>
            <dd  >
             
              <span   class="note">衡水银行</span>
            </dd>
           
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-9.png">
            </dt>
            <dd  >
              <span   class="note">冀州中学</span>
            </dd>
          </dl>
          <dl >
            <dt  >
              <img src="../../static/img/school-10.png">
            </dt>
            <dd  >
              <span   class="note">志臻实验中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-11.png">
            </dt>
            <dd  >
              <span   class="note">南宫中学</span>
            </dd>
          </dl>
          <dl  >
            <dt  >
              <img src="../../static/img/school-12.png">
            </dt>
            <dd  >
             
              <span   class="note">苍龙国际学校</span>
            </dd>
           
          </dl>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  export default {
    name: 'HelloWorld',
    data () {
      return {

      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    methods: {

    }

  }
</script>
<style lang="">
  .my-swipetwo .mint-swipe-indicators{
    display: none !important;
    border-radius: 0 !important;
  }
.my-swipetwo .mint-swipe-indicator{
    display: none !important;
    border-radius: 0 !important;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .banner{
    width: 100%;
    color: #fff;
    position: relative;
  }
  .banner img{
    width: 100%;
  }

  .banner .item-title{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
  }
  .banner .item-title .ch{
    font-size:40px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(255,255,255,1);
  }
    .banner .item-title .egone{
      width:250px;
height:4px;
background:rgba(255,255,255,1);
text-align: center;
margin: 30px auto;
    }
  .banner .item-title .eg{
    font-size:22px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:33px;
width:606px;
  }
  .item-title .eg{
    font-size: 12px;
    margin-bottom: 5px;
  }



  .content{
    padding: 50px 0;
    box-sizing: border-box;
    position: relative;
  }
  .content .border-line.border-line-top:before {
    content: "";
    height: 4px;
    width: 50px;
    background: #666;
    position: absolute;
    left: -12px;
    top: 26px;
    transform: rotate(90deg);
  }
  .content .border-line.border-line-top:after {
    content: "";
    height: 4px;
    width: 50px;
    background: #666;
    position: absolute;
    left: 11px;
    top: 0;
  }
  .content .border-line.border-line-bottom:before {
    content: "";
    height: 4px;
    width: 50px;
    background: #666;
    position: absolute;
    left: 0;
    top: -27px;
    transform: rotate(90deg);
  }
  .content .border-line.border-line-bottom:after {
    content: "";
    height: 4px;
    width: 50px;
    background: #666;
    position: absolute;
    left: -23px;
    top: 0;
  }
  .content .border-line{
    position: absolute;
  }
  .content .border-line.border-line-top{
    top: 46px;
    left: 4px;
  }
  .content .border-line.border-line-bottom{
    bottom: 54px;
    right: 45px;
  }
  .content>p{
    padding: 20px 40px;
    margin: 0;
  }
  .product-introduction{
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px;
  }
  .solution  {
   padding: 100px 0;
  }

  .solution .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    /* margin-top: 80px; */
   margin: 60px  auto 0 auto;
    width:702px;
    height:580px;
    background:rgba(255,255,255,1);
    border-radius:20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  padding-bottom: 20px;
  }
.solution .my-swipetwo{
    height:700px;
    
}

  .solution .item-pro dl  {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    /* height:580px; */
  }

  .solution .item-pro dl img  {
   width:200px;
  height:200px;
  margin-top: 60px;
  margin-bottom: 10px;
  }

  .solution .item-pro dd ,.solution .item-pro dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .solution .item-pro dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
text-align: center;
    font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:21px;
  }
.solution .item-pro dd .titlies{
font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:21px;
margin: 30px 0;
}
  .solution .item-pro dd .note  {
    margin-top: 5px;
    text-align: center;
    letter-spacing: .5px;
width:602px;
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
  }

  .productfooter{
 background-image: url('~@/../static/img/s-footer-bg.png');
    background-size: 100% 100%;
padding: 100px 0;
}
  .productfooter .item-pro  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 40px;
    /* margin-bottom: 50px; */
    width: 89%;
    margin: 0 auto;
  }
  .productfooter .item-pro dl  {
    width: 30%;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 46px;
  }
  .productfooter .item-pro dl img  {
    /* height: 79px */
    width: 100px;
    height: 100px;
  }

  .productfooter .item-pro dd ,.productfooter .item-pro dt  {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center
  }

  .productfooter .item-pro dd  {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
     margin-top: 10px;
    text-align: center;
    font-size:20px;
font-family:PingFang SC;
font-weight:400;
color:rgba(33,33,33,1);
line-height:27px;
  }

 .productfooter .item-pro dd .note  {
   
    margin-top: 10px;
    text-align: center;
    font-size:20px;
font-family:PingFang SC;
font-weight:400;
color:rgba(33,33,33,1);
line-height:27px;
  }
    .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    /* margin-top: 100px; */
  }
  .item-title .eg {
    margin-bottom: 20px;
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(0,0,0,1);
  }
  .item-title .ch {
    /* margin-bottom: 80px; */
    width:508px;
    height:60px;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
/* line-height:36px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/companyprofile.vue